<template>
    <!-- Content Header (Page header) -->
    <div v-if="halamanloading" style="height: 100%;width: 100%; background-color: black;position:absolute;z-index: 1000;
  left: 0;top: 0;opacity: 0.75; align-content: center;color: aliceblue;text-align: center;vertical-align: middle;
  filter: progid:DXImageTransform.Microsoft.Alpha(opacity=50);background-position: center center;">
        <h1>
            <br><br><br><br><br>
            <img class="animation__shake" src="../../assets/img/logo_pu.jpg" style="height: 70px;position: center center;">
            <br><br>.. LOADING ..
        </h1>
    </div>
    <div class="content-header">
        <div class="container-fluid">
            <div class="col-md-12 text-justify">
                &nbsp;
            </div>
            <div class="row mb-2">
                <div class="col-sm-6">
                    <h3><a href="/DetailPaket">Detail Paket Kontraktual</a></h3>
                </div>
                <!-- /.col -->
                <div class="col-sm-6">
                    <ol class="breadcrumb float-sm-right">
                        <li class="breadcrumb-item active"><a href="#"><v-text-field label="Label"
                                    class="form-control form-control-sm" aria-disabled="true"> Tanggal {{
                                        G_formatDate(tanggalsekarang)
                                    }}</v-text-field></a>
                        </li>
                    </ol>
                </div>
                <!-- /.col -->
            </div>
            <!-- /.row -->
        </div>
        <!-- /.container-fluid -->
    </div>

    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12 text-justify">
                    <div class="card card-warning collapsed-card">
                        <div class="card-header">
                            <h3 class="card-title">Filter Data</h3>

                            <div class="card-tools">
                                <button type="button" class="btn btn-tool" data-card-widget="collapse"><i
                                        class="fas fa-plus"></i>
                                </button>
                            </div>
                            <!-- /.card-tools -->
                        </div>
                        <!-- /.card-header -->
                        <div class="card-body">
                            <div class="carddataputih">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <label style="font-size: small;">Sumber Dana</label>
                                            <v-select :options="SumberDana" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedSumberDana"
                                                @update:modelValue="onSumberDanaChange"></v-select>
                                        </div>
                                        <div class="col-lg-6">
                                            <label style="font-size: small;">Lender</label>
                                            <v-select :options="donor" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedDonor"
                                                @update:modelValue="onDonorChange"></v-select>
                                        </div>
                                        <div class="col-lg-6">
                                            <label style="font-size: small;">Pusat/Balai</label>
                                            <v-select :options="balai" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedBalai"
                                                @update:modelValue="onBalaiChange"></v-select>
                                        </div>
                                        <div class="col-lg-6">
                                            <label style="font-size: small;">Satker</label>
                                            <v-select :options="satker" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedSatker"
                                                @update:modelValue="onSatkerChange"></v-select>
                                        </div>
                                        <div class="col-lg-6">
                                            <label style="font-size: small;">Register</label>
                                            <v-select :options="register" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedRegister"
                                                @update:modelValue="onRegisterChange"></v-select>
                                        </div>
                                        <div class="col-lg-2">
                                            <label style="font-size: small;">Pilihan Tahun</label>
                                            <v-select :options="tahun" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedTahun"
                                                @update:modelValue="onTahunChange"></v-select>
                                        </div>
                                        <div class="col-lg-2">
                                            <label style="font-size: small;">Opsi</label>
                                            <div class="col-lg-12">
                                                <div class="btn-group">
                                                    <button type="button" class="btn btn-success btn-sm"
                                                        style="width: 100%;">Export</button>
                                                    <button type="button"
                                                        class="btn btn-success dropdown-toggle dropdown-icon"
                                                        data-toggle="dropdown">
                                                        <span class="sr-only">Toggle Dropdown</span>
                                                    </button>
                                                    <div class="dropdown-menu" role="menu">
                                                        <a class="dropdown-item" href="#"
                                                            @click="G_tableCSV('_Detail_Paket_Kontraktual_Tgl_Data_')">Excel</a>
                                                        <a class="dropdown-item" href="#" @click="printContent()">Print</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- /.row -->
                                </div>
                                <!-- /.card-body -->
                            </div>
                            <!-- /.cardputih -->
                        </div>
                        <!-- /.card-body -->
                    </div>
                </div>
                <!-- /.col-md-12 text-center -->
                <div class="col-md-12 text-justify">
                    <div class="card card-pupr collapsed-card">
                        <div class="card-header">
                            <h3 class="card-title">Show / Hide Kolom</h3>
                            <div class="card-tools">
                                <button type="button" class="btn btn-tool" data-card-widget="collapse"><i
                                        class="fas fa-plus"></i>
                                </button>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="cardputih">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-lg-2 col-6">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" checked="checked" id="customCheckboxKode"
                                                    value="optionKode" @click="showColumnKode = !showColumnKode">
                                                <label for="customCheckboxKode" class="custom-control-label">Kode</label>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-6">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxNamaPaket" value="optionNamaPaket"
                                                    @click="showColumnNamaPaket = !showColumnNamaPaket">
                                                <label for="customCheckboxNamaPaket" class="custom-control-label">Nama
                                                    Paket</label>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-6">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxPagu" value="optionPagu"
                                                    @click="showColumnPagu = !showColumnPagu">
                                                <label for="customCheckboxPagu" class="custom-control-label">Pagu
                                                    Pake</label>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-6">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxStatus" value="optionStatus"
                                                    checked="checked" @click="showColumnStatus = !showColumnStatus">
                                                <label for="customCheckboxStatus"
                                                    class="custom-control-label">Status</label>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-6">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxPaguLelang" value="optionPaguLelang"
                                                    @click="showColumnPaguLelang = !showColumnPaguLelang">
                                                <label for="customCheckboxPaguLelang" class="custom-control-label">Pagu
                                                    Lelang</label>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-6">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxNM" value="optionNM"
                                                    @click="showColumnNM = !showColumnNM">
                                                <label for="customCheckboxNM" class="custom-control-label">Metode
                                                    Lelang</label>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-6">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxTS" value="optionTS"
                                                    @click="showColumnTS = !showColumnTS">
                                                <label for="customCheckboxTS" class="custom-control-label">Tahapan
                                                    Sekarang</label>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-6">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxNK" value="optionNK"
                                                    @click="showColumnNK = !showColumnNK">
                                                <label for="customCheckboxNK" class="custom-control-label">Nilai
                                                    Kontrak</label>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-6" style="display: none;">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-danger"
                                                    type="checkbox" id="customCheckboxSL" value="optionNK"
                                                    @click="showColumnSL = !showColumnSL">
                                                <label for="customCheckboxSL" class="custom-control-label">Sisa
                                                    Lelang</label>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-6" style="display: none;">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-success"
                                                    type="checkbox" id="customCheckboxKP" value="optionKP"
                                                    @click="showColumnKP = !showColumnKP">
                                                <label for="customCheckboxKP" class="custom-control-label">Kategori
                                                    Paket</label>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-6">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxNomK" value="optionNomK"
                                                    @click="showColumnNomK = !showColumnNomK">
                                                <label for="customCheckboxNomK" class="custom-control-label">Nomor
                                                    Kontrak</label>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-6">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-success"
                                                    type="checkbox" id="customCheckboxTK" value="optionTK"
                                                    @click="showColumnTK = !showColumnTK">
                                                <label for="customCheckboxTK" class="custom-control-label">Tanggal
                                                    Kontrak</label>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-6">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-danger"
                                                    type="checkbox" id="customCheckboxNR" value="optionNR"
                                                    @click="showColumnNR = !showColumnNR">
                                                <label for="customCheckboxNR" class="custom-control-label">Nama
                                                    Rekanan</label>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-6">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-danger"
                                                    type="checkbox" id="customCheckboxKKPPN" value="optionKKPPN"
                                                    @click="showColumnKKPPN = !showColumnKKPPN">
                                                <label for="customCheckboxKKPPN" class="custom-control-label">Kode
                                                    KPPN</label>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-6">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-success"
                                                    type="checkbox" id="customCheckboxKB" value="optionKB"
                                                    @click="showColumnKB = !showColumnKB">
                                                <label for="customCheckboxKB" class="custom-control-label">Kode
                                                    Beban</label>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- /.row -->
                                </div>
                                <!-- /.card-body -->
                            </div>
                        </div>
                    </div>
                    <!-- /.cardputih -->
                </div>
            </div>
            <div class="row">&nbsp;</div>
            <div class="row">
                <div class="col-md-12 text-justify">
                    <div class="cardputih">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-4 text-justify"></div>
                                <div class="col-sm-4 text-center">
                                    <v-text-field label="Label" class="form-control form-control-sm" aria-disabled="true"
                                        style="background-color: #354777;
                  color:#ffffff;font-size: smaller;border-top-left-radius: 50px;border-bottom-left-radius: 50px;
                  border-top-right-radius: 50px;border-bottom-right-radius: 50px;
                  border-left: #ffc107 solid 20px;border-right: #ffc107 solid 20px;"> Tanggal Data: {{
                      G_formatDate(tanggaldata)
                  }}</v-text-field>
                                </div>
                                <div class="col-sm-4 text-justify"></div>
                                <div class="col-sm-12 text-justify">&nbsp;</div>
                                <div class="col-sm-1 text-justify">
                                    <label style="font-size: small;">Pencarian</label>
                                </div>
                                <div class="col-sm-11 text-justify">
                                    <input type="text" v-model="carikata" class="form-control form-control-sm"
                                        placeholder="Masukkan Kata Kunci Pencarian">
                                </div>
                                <div class="col-md-12 text-justify">&nbsp;</div>
                                <div class="col-md-12 text-justify"><span class="totalrecordtabel">Total Baris Data Tabel:
                                        {{
                                            G_numFormat(JumlahfilteredKata) }} </span></div>
                            </div>
                            <div class="table-wrapper">
                                <table class="table table table-bordered table-hover" id="tabeldata">
                                    <thead class="cf">
                                        <tr>
                                            <th style="width: 70px;">No</th>
                                            <th style="width: 220px;" v-if="showColumnKode">Kode Paket Kontraktual</th>
                                            <th style="width: 450px;" v-if="showColumnNamaPaket">Nama Paket</th>
                                            <th style="width: 450px;">Nama<br>Paket<br>Kontraktual</th>
                                            <th v-if="showColumnPagu">Pagu<br>Paket<br>(Rp.)</th>
                                            <th>Pagu<br>Paket<br>Kontraktual<br>(Rp.)</th>
                                            <th>Kode<br>Proyek</th>
                                            <th v-if="showColumnStatus">Status</th>
                                            <th v-if="showColumnPaguLelang">Pagu<br>Lelang /<br>Pengadaan<br>(Rp.)</th>
                                            <th v-if="showColumnNM">Metode<br>Lelang</th>
                                            <th v-if="showColumnTS" style="width: 150px;">Tahapan<br>Sekarang</th>
                                            <th v-if="showColumnNK">Nilai<br>Kontrak<br>(Rp.)</th>
                                            <th v-if="showColumnNomK" style="width: 150px;">Nomor<br>Kontrak</th>
                                            <th v-if="showColumnTK" style="width: 150px;">Tanggal<br>Kontrak
                                            </th>
                                            <th v-if="showColumnNR" style="width: 250px;">Nama<br>Rekanan</th>
                                            <th v-if="showColumnSL" style="display: none;">Sisa Lelang<br>(Rp.)</th>
                                            <th v-if="showColumnKP" style="display: none;">Kategori<br>Paket</th>
                                            <th v-if="showColumnKKPPN">Kode KPPN</th>
                                            <th v-if="showColumnKB">Kode Beban</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="total"> TOTAL</td>
                                            <td class="total" v-if="showColumnKode"></td>
                                            <td class="total" v-if="showColumnNamaPaket"></td>
                                            <td class="total"></td>
                                            <td class="totalkanan" v-if="showColumnPagu">{{ G_numFormat(totalpagupaket) }}
                                            </td>
                                            <td class="totalkanan">{{ G_numFormat(totalpagu) }}</td>
                                            <td class="total"></td>
                                            <td class="total" v-if="showColumnStatus"></td>
                                            <td class="total" v-if="showColumnPaguLelang"></td>
                                            <td class="total" v-if="showColumnNM"></td>
                                            <td class="total" v-if="showColumnTS"></td>
                                            <td class="totalkanan" v-if="showColumnNK">{{ G_numFormat(totalrealisasi) }}
                                            </td>
                                            <td class="total" v-if="showColumnNomK"></td>
                                            <td class="total" v-if="showColumnNR"></td>
                                            <td class="totalkanan" v-if="showColumnSL" style="display: none;">{{
                                                G_numFormat(totalrata2keu) }}</td>
                                            <td class="total" v-if="showColumnKP" style="display: none;"></td>
                                            <td class="total" v-if="showColumnTK"></td>
                                            <td class="total" v-if="showColumnKKPPN"></td>
                                            <td class="total" v-if="showColumnKB"></td>
                                        </tr>
                                        <tr v-for="(dataparent, urutparent) in filteredKata" :key="urutparent">
                                            <td style="width: 70px;"
                                                :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
                                                    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
                                                        dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
                                                            dataparent.Class == 'kolomoutput' ? 'kolomoutput' : 'kolomsatker'))]">
                                                {{ dataparent.No }}</td>
                                            <td :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
                                                (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
                                                    dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
                                                        dataparent.Class == 'kolomoutput' ? 'kolomoutput' : 'kolomsatker'))]"
                                                v-if="showColumnKode">
                                                {{ dataparent.Kode }}</td>
                                            <td style="width: 250px;"
                                                :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
                                                    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
                                                        dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
                                                            dataparent.Class == 'kolomoutput' ? 'kolomoutput' : 'kolomsatker'))]"
                                                v-if="showColumnNamaPaket">
                                                {{ dataparent.KodePaket['nmpaket'] }}</td>
                                            <td
                                                :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
                                                    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
                                                        dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
                                                            dataparent.Class == 'kolomoutput' ? 'kolomoutput' : 'kolomsatker'))]">
                                                {{ dataparent.Kegiatan }}
                                            </td>
                                            <td :class="[(dataparent.Class == 'kolompusat' ? 'kolompusatkanan' :
                                                (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektoratkanan' :
                                                    dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatankanan' :
                                                        dataparent.Class == 'kolomoutput' ? 'kolomoutputkanan' : 'kolomsatkerkanan'))]"
                                                v-if="showColumnPagu">
                                                {{ G_numFormat(dataparent.PaguPaket || 0) }}
                                            </td>
                                            <td
                                                :class="[(dataparent.Class == 'kolompusat' ? 'kolompusatkanan' :
                                                    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektoratkanan' :
                                                        dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatankanan' :
                                                            dataparent.Class == 'kolomoutput' ? 'kolomoutputkanan' : 'kolomsatkerkanan'))]">
                                                {{ G_numFormat(dataparent.pg) }}</td>
                                            <td
                                                :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
                                                    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
                                                        dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
                                                            dataparent.Class == 'kolomoutput' ? 'kolomoutput' : 'kolomsatker'))]">
                                                {{ dataparent.proyeks }}</td>
                                            <td :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
                                                (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
                                                    dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
                                                        dataparent.Class == 'kolomoutput' ? 'kolomoutput' : 'kolomsatker'))]"
                                                v-if="showColumnStatus">
                                                {{ dataparent.status }}</td>
                                            <td :class="[(dataparent.Class == 'kolompusat' ? 'kolompusatkanan' :
                                                (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektoratkanan' :
                                                    dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatankanan' :
                                                        dataparent.Class == 'kolomoutput' ? 'kolomoutputkanan' : 'kolomsatkerkanan'))]"
                                                v-if="showColumnPaguLelang">
                                                {{ G_numFormat(dataparent.pgp) }}</td>
                                            <td v-if="showColumnNM"
                                                :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
                                                    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
                                                        dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
                                                            dataparent.Class == 'kolomoutput' ? 'kolomoutput' : 'kolomsatker'))]">
                                                {{ dataparent.nmMetode }}</td>
                                            <td v-if="showColumnTS"
                                                :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
                                                    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
                                                        dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
                                                            dataparent.Class == 'kolomoutput' ? 'kolomoutput' : 'kolomsatker'))]">
                                                {{ dataparent.tahapanSkrg }}</td>
                                            <td v-if="showColumnNK"
                                                :class="[(dataparent.Class == 'kolompusat' ? 'kolompusatkanan' :
                                                    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektoratkanan' :
                                                        dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatankanan' :
                                                            dataparent.Class == 'kolomoutput' ? 'kolomoutputkanan' : 'kolomsatkerkanan'))]">
                                                {{ G_numFormat(dataparent.nkon) }}</td>
                                            <td v-if="showColumnNomK"
                                                :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
                                                    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
                                                        dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
                                                            dataparent.Class == 'kolomoutput' ? 'kolomoutput' : 'kolomsatker'))]">
                                                {{ dataparent.nomorKontrak }}</td>
                                            <td v-if="showColumnTK"
                                                :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
                                                    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
                                                        dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
                                                            dataparent.Class == 'kolomoutput' ? 'kolomoutput' : 'kolomsatker'))]">
                                                {{ G_formatDate_Tanpa_WIB(dataparent.tanggalKontrak) }}</td>
                                            <td v-if="showColumnNR"
                                                :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
                                                    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
                                                        dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
                                                            dataparent.Class == 'kolomoutput' ? 'kolomoutput' : 'kolomsatker'))]">
                                                {{ dataparent.rknName }}</td>
                                            <td v-if="showColumnSL"
                                                :class="[(dataparent.Class == 'kolompusat' ? 'kolompusatkanan' :
                                                    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektoratkanan' :
                                                        dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatankanan' :
                                                            dataparent.Class == 'kolomoutput' ? 'kolomoutputkanan' : 'kolomsatkerkanan'))]"
                                                style="display: none;">
                                                {{ G_numFormat(dataparent.sisaLelang) }}</td>
                                            <td v-if="showColumnKP"
                                                :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
                                                    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
                                                        dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
                                                            dataparent.Class == 'kolomoutput' ? 'kolomoutput' : 'kolomsatker'))]"
                                                style="display: none;">
                                                {{ dataparent.nmKategori }}</td>
                                            <td v-if="showColumnKKPPN"
                                                :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
                                                    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
                                                        dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
                                                            dataparent.Class == 'kolomoutput' ? 'kolomoutput' : 'kolomsatker'))]">
                                                {{ dataparent.kdkppns }}</td>
                                            <td v-if="showColumnKB"
                                                :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
                                                    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
                                                        dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
                                                            dataparent.Class == 'kolomoutput' ? 'kolomoutput' : 'kolomsatker'))]">
                                                {{ dataparent.kdbebans }}</td>
                                        </tr>
                                    </tbody>

                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- /.container-fluid -->
    </div>
    <!-- /.content -->
</template>
      
<script>
import $ from 'jquery';
import axios from "axios";
//import Vueaxios from "vue-axios";
import vSelect from 'vue-select';
import "datatables.net-bs4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css";
import xlsx from 'xlsx/dist/xlsx.full.min';
//import { Doughnut } from "vue-chartjs";
//import Chart from 'chart.js'

export default {
    components: {
        vSelect,
    },
    data() {
        return {
            carikata: '',
            cekbalai: [],
            showColumnKode: true,
            showColumnNamaPaket: false,
            showColumnStatus: true,
            showColumnPaguLelang: false,
            showColumnPagu: false,
            showColumnNK: false,
            showColumnSL: false,
            showColumnKP: false,
            showColumnNomK: false,
            showColumnNR: false,
            showColumnTK: false,
            showColumnNM: false,
            showColumnKKPPN: false,
            showColumnKB: false,
            showColumnTS: false,
            halamanloading: true,
            datatabel: [],
            detailtabel: [],
            tabeldataHTML: "",
            defaultSelectedSumberDana: {
                code: 0,
                label: 'PHLN'
            },
            SumberDana: [
                { code: 0, label: 'PHLN' }, { code: 1, label: 'SBSN' }
            ],
            sumberdanafilter: 'pln',
            hasLoanOnlyfiler: true,
            hasSbsnOnlyfilter: false,

            defaultSelectedBalai: {
                code: "0",
                label: "Semua Pusat dan Balai"
            },
            kdbalaifilter: "",
            datamasterbalai: [],
            balai: [],

            defaultSelectedSatker: {
                code: "0",
                label: "Semua Satker"
            },
            kdsatkerfilter: "",
            datamastersatker: [],
            satker: [],

            defaultSelectedProyek: {
                code: "0",
                label: "Semua Proyek"
            },
            kdProyekfilter: "",
            datamasterProyek: [],
            Proyek: [],

            defaultSelectedRegister: {
                code: "0",
                label: "Semua Register"
            },
            koderegisterfilter: "",
            register: [],

            defaultSelectedTahun: {
                code: 0,
                label: localStorage.getItem("TahunAktif"),
            },
            tahunfilter: localStorage.getItem("TahunAktif"),
            datatahun: [],
            tahun: [],

            defaultSelectedDetailSatker: {
                code: 0,
                label: 'Tidak'
            },
            DetailSatker: [
                { code: 0, label: 'Tidak' }, { code: 1, label: 'Ya' }
            ],
            detailsatkerfilter: false,

            defaultSelectedDonor: {
                code: "0",
                label: "Semua Lender"
            },
            kddonorfilter: "",
            datamasterdonor: [],
            donor: [],

            ///// rekap
            adit: [],
            aditjumlah: [],
            datarekap: [],
            tanggaldata: '',
            totalpagu: '0',
            totalrealisasi: '0',
            totalrata2keu: '0',
            totalrata2fisik: '0',
            rata2keu: '0',
            rata2fisik: '0',
            totalpagupaket: 0,
            totalbalai: 0,
            totalsatker: 0,
            framework: [],
            tanggalsekarang: new Date(),
        }
    },
    computed: {
        computeditemsDataProyek: function () {
            return this.Proyek.filter(function (item) {
                return item.label != "TEST-Test Edit";
            })
        },
        filteredKata() {
            const filteredWorkers = this.carikata === ""
                ? this.detailtabel
                : this.detailtabel.filter(wo => Object.values(wo).join("").toLowerCase().indexOf(this.carikata.toLowerCase()) !== -1);
            return filteredWorkers;
        },
        JumlahfilteredKata() {
            var jumlah = 0;
            try {
                if (this.filteredKata === undefined) {
                    jumlah = 0;
                } else {
                    jumlah = this.filteredKata.length;
                }
            }
            catch {
                jumlah = 0;
            }
            return jumlah;
        },
    },
    methods: {
        printContent() {
            var divToPrint = document.getElementById('tabeldata');
            var htmlToPrint = '' +
                '<style type="text/css">' +
                'table th, table td {' +
                'border:1px solid #000;' +
                '}' +
                '</style>';
            htmlToPrint += divToPrint.outerHTML;
            const printWindow = window.open('', '', 'height=1000,width=1000')
            printWindow.document.write(htmlToPrint)
            printWindow.print()

        },
        async G_tableCSV(namefile) {
            this.framework = [];
            this.halamanloading = true;
            JSON.parse(localStorage.getItem("userLogin"));
            const mainAPIRekap = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            });
            await mainAPIRekap.get("kontraktual/per-paket/nested?tahun=" + this.tahunfilter +
                "&hasProyekOnly=true&realisasi=&includeRegister=false&includeKppn=false&includeBeban=false&includeMetode=false&hasLoanOnly=" + this.hasLoanOnlyfiler
                + "&hasSbsnOnly=" + this.hasSbsnOnlyfilter + "&kdsatker="
                + this.kdsatkerfilter + "&kdbalai=" + this.kdbalaifilter + "&register=" + this.koderegisterfilter + "&lender=" + this.kddonorfilter)
                .then(
                    Response => {
                        this.datarekap = Response.data;
                        //console.log(this.datarekap);
                        this.datatabel = Response.data.content;
                        this.tanggaldata = this.datarekap.tanggalEmon;


                        for (let i = 0; i < this.datatabel.length; i++) {
                            let found = this.balai.find((element) => element.code == this.datatabel[i].kdbalai);
                            this.framework.push({
                                "No": i + 1,
                                "Kode Sub Paket": "",
                                "Kegiatan/Output/Sub Paket": found.label,
                                "Status": '',
                                "Kode Proyek": '',
                                "Pagu (Rp.)": this.datatabel[i].pg,
                                "Nilai Kontrak (Rp.)": this.datatabel[i].nkon,
                                "Sisa Lelang (Rp.)": this.datatabel[i].sisaLelang,
                                "Kategori Paket": '',
                                "Nomor Kontrak": '',
                                "Nama Rekanan": '',
                                "Tanggal Kontrak": '',
                                "Nama Metode": '',
                                "Kode KPPN": '',
                                "Kode Beban": '',
                                "Tahapan Sekarang": '',

                            })
                            for (let z = 0; z < this.datatabel[i].childs.length; z++) {
                                if (this.datatabel[i].childs[z].pg) {
                                    this.framework.push({
                                        "No": (i + 1) + "." + (z + 1),
                                        "Kode Sub Paket": this.datatabel[i].childs[z].kode,
                                        "Kegiatan/Output/Sub Paket": this.datatabel[i].childs[z].nmsatker || '',
                                        "Status": '',
                                        "Kode Proyek": '',
                                        "Pagu (Rp.)": this.datatabel[i].childs[z].pg || 0,
                                        "Nilai Kontrak (Rp.)": this.datatabel[i].childs[z].nkon,
                                        "Sisa Lelang (Rp.)": this.datatabel[i].childs[z].sisaLelang,
                                        "Kategori Paket": '',
                                        "Nomor Kontrak": '',
                                        "Nama Rekanan": '',
                                        "Tanggal Kontrak": '',
                                        "Nama Metode": '',
                                        "Kode KPPN": '',
                                        "Kode Beban": '',
                                        "Tahapan Sekarang": '',

                                    })
                                    for (let c = 0; c < this.datatabel[i].childs[z].childs.length; c++) {
                                        if (this.datatabel[i].childs[z].childs[c].pg) {
                                            this.framework.push({
                                                "No": (i + 1) + "." + (z + 1) + "." + (c + 1),
                                                "Kode Sub Paket": this.datatabel[i].childs[z].childs[c].kode,
                                                "Kegiatan/Output/Sub Paket": this.datatabel[i].childs[z].childs[c].nmpaket || '',
                                                "Status": this.datatabel[i].childs[z].childs[c].status || '',
                                                "Kode Proyek": this.datatabel[i].childs[z].childs[c].proyeks[0] || '',
                                                "Pagu (Rp.)": this.datatabel[i].childs[z].childs[c].pg || 0,
                                                "Nilai Kontrak (Rp.)": this.datatabel[i].childs[z].childs[c].nkon || 0,
                                                "Sisa Lelang (Rp.)": this.datatabel[i].childs[z].childs[c].sisaLelang || 0,
                                                "Kategori Paket": this.datatabel[i].childs[z].childs[c].nmKategori || '',
                                                "Nomor Kontrak": this.datatabel[i].childs[z].childs[c].nomorKontrak || '',
                                                "Nama Rekanan": this.datatabel[i].childs[z].childs[c].rknName || '',
                                                "Tanggal Kontrak": this.datatabel[i].childs[z].childs[c].tanggalKontrak || '',
                                                "Nama Metode": this.datatabel[i].childs[z].childs[c].nmMetode || '',
                                                "Kode KPPN": this.datatabel[i].childs[z].childs[c].kdkppns[0] || '',
                                                "Kode Beban": this.datatabel[i].childs[z].childs[c].kdbebans[0] || '',
                                                "Tahapan Sekarang": this.datatabel[i].childs[z].childs[c].tahapanSkrg || '',

                                            })
                                        }
                                    }
                                }
                            }
                        }

                        function formatColumn(worksheet, col, fmt) {
                            const range = XLSX.utils.decode_range(worksheet['!ref'])
                            // note: range.s.r + 1 skips the header row
                            for (let row = range.s.r + 1; row <= range.e.r; ++row) {
                                const ref = XLSX.utils.encode_cell({ r: row, c: col })
                                if (worksheet[ref] && worksheet[ref].t === 'n') {
                                    worksheet[ref].z = fmt
                                }
                            }
                        }
                        const currency = '0.00';

                        const XLSX = xlsx;
                        const workbook = XLSX.utils.book_new();
                        const worksheet = XLSX.utils.json_to_sheet(this.framework);

                        for (let col of [4, 5, 6, 7]) {
                            formatColumn(worksheet, col, currency)
                        }

                        XLSX.utils.book_append_sheet(workbook, worksheet, "framework");
                        XLSX.writeFile(workbook, this.G_formatDate(Date(), 'd-M-Y') + namefile + this.G_formatDate(this.tanggaldata) + ".xlsx");
                        this.halamanloading = false;
                    }
                ).catch(error => {
                    console.log(error);
                    this.halamanloading = false;
                    //window.location.replace("/");
                });



        },
        onDonorChange(a) {
            let selectedIsi = this.donor[a].label;
            this.kddonorfilter = "";
            if (selectedIsi != 'Semua Lender') { this.kddonorfilter = selectedIsi }
            //console.log(this.kddonorfilter)
            this.koderegisterfilter = '';
            this.defaultSelectedRegister = {
                code: "0",
                label: "Semua Register"
            };
            this.AmbilDataRegister();
            this.ambildataUpdate();
        },
        onRegisterChange(a) {
            localStorage.removeItem('RegisterRekapSDA');
            let selectedIsi = this.register[a].tag;
            let filter = selectedIsi;
            this.koderegisterfilter = "";
            if (filter != 'Semua Register') { this.koderegisterfilter = filter }
            //alert(this.koderegisterfilter);
            this.ambildataUpdate();
            //console.log(this.koderegisterfilter);
        },
        onProyekChange(a) {
            localStorage.removeItem('ProyekRekapSDA');
            let selectedIsi = this.Proyek[a].tag;
            let filter = selectedIsi;
            this.kdProyekfilter = "";
            if (filter != 'Semua Proyek') { this.kdProyekfilter = filter }
            // console.log(this.kdProyekfilter);
            this.ambildataUpdate();
        },
        onBalaiChange(a) {
            localStorage.removeItem('BalaiRekapSDA');
            let selectedIsi = this.balai[a].code;
            this.kdbalaifilter = "";
            if (selectedIsi != 0) { this.kdbalaifilter = selectedIsi }
            this.kdsatkerfilter = "";
            this.defaultSelectedSatker = {
                code: "0",
                label: "Semua Satker"
            };
            this.AmbilDataSatker();
            //console.log(selectedIsi);
            this.ambildataUpdate();
        },
        onSatkerChange(a) {
            localStorage.removeItem('SatkerRekapSDA');
            let selectedIsi = this.satker[a].tag;
            this.kdsatkerfilter = "";
            if (selectedIsi != 0) { this.kdsatkerfilter = selectedIsi }
            //console.log(selectedIsi);
            this.ambildataUpdate();
        },
        onSumberDanaChange(a) {
            localStorage.removeItem('SumberDanaRekapSDA');
            let selectedIsi = this.SumberDana[a].code;
            this.hasLoanOnlyfiler = true;
            this.hasSbsnOnlyfilter = false;
            this.sumberdanafilter = 'pln';
            if (selectedIsi == 1) { this.hasLoanOnlyfiler = true; this.hasSbsnOnlyfilter = true; this.sumberdanafilter = 'sbsn'; }
            this.kddonorfilter = "";
            //console.log(this.kddonorfilter)
            this.defaultSelectedDonor = {
                code: "0",
                label: "Semua Lender"
            };
            this.AmbilDataDonor();
            this.koderegisterfilter = '';
            this.defaultSelectedRegister = {
                code: "0",
                label: "Semua Register"
            };
            this.AmbilDataRegister();
            this.ambildataUpdate();
        },
        onTahunChange(a) {
            localStorage.removeItem('TahunRekapSDA');
            let selectedtahun = this.tahun[a].label;
            this.tahunfilter = selectedtahun;
            this.ambildataUpdate();
        },
        async ambildataUpdate() {
            this.halamanloading = true;
            this.AmbilDataRekap();
        },
        initializeSelect2() {
            //Initialize Select2 Elements
            $(".select2").select2();

            //Initialize Select2 Elements
            $(".select2bs4").select2({
                theme: "bootstrap4",
            });
        },
        async AmbilDataBalai() {
            this.halamanloading = true;
            JSON.parse(localStorage.getItem("userLogin"));
            this.cekbalai = JSON.parse(localStorage.getItem("userLogin"));
            const mainAPIMaster = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            });
            await mainAPIMaster.get("reff/balai")
                .then(
                    Response => {
                        //console.log(Response.data);
                        this.datamasterbalai = Response.data.content;
                        //console.log(this.datamasterdonor);
                        this.datamasterbalai.forEach((item) => {
                            this.balai.push({
                                label: item.nmbalai,
                                code: item.kdbalai,
                            });
                        });
                        if (this.cekbalai.kdbalai == null) {
                            this.balai.unshift({
                                label: 'Semua Pusat dan Balai',
                                code: '0',
                            });
                        }
                        else {
                            this.defaultSelectedBalai = this.balai;
                            //this.selectedbalai = this.balai[0].label;
                            this.kdbalaifilter = this.balai[0].code;
                            //console.log("Balai"+this.selectedbalai);
                        }
                        //console.log(this.donor);

                    }
                ).catch(error => {
                    console.log(error);
                    this.halamanloading = false;
                    window.location.replace("/");
                })
        },
        async AmbilDataSatker() {
            this.halamanloading = true;
            JSON.parse(localStorage.getItem("userLogin"));
            const mainAPIMaster = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            });
            await mainAPIMaster.get("reff/satker?kdbalai=" + this.kdbalaifilter)
                .then(
                    Response => {
                        //console.log(Response.data);
                        this.satker = [];
                        this.datamastersatker = Response.data.content;
                        //console.log(this.datamasterdonor);
                        this.datamastersatker.forEach((item) => {
                            this.satker.push({
                                label: item.satkerNm,
                                code: this.datamastersatker.indexOf(item) + 1,
                                tag: item.satkerId,
                            });
                        });
                        this.satker.unshift({
                            label: 'Semua Satker',
                            code: '0',
                            tag: '0',
                        });
                        //console.log(this.donor);

                    }
                ).catch(error => {
                    console.log(error);
                    this.halamanloading = false;
                    window.location.replace("/");
                })
        },
        async AmbilDataDonor() {
            this.halamanloading = true;
            JSON.parse(localStorage.getItem("userLogin"));
            const mainAPIMaster = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            });
            await mainAPIMaster.get("reff/donor?sumberDana=" + this.sumberdanafilter)
                .then(
                    Response => {
                        //console.log(Response.data);
                        this.donor = [];
                        this.datamasterdonor = Response.data;
                        //console.log(this.datamasterdonor);
                        this.datamasterdonor.forEach((item) => {
                            this.donor.push({
                                label: item,
                                code: this.datamasterdonor.indexOf(item) + 1,
                            });
                        });
                        this.donor.unshift({
                            label: 'Semua Lender',
                            code: '0',
                        });
                        //console.log(this.donor);
                    }
                ).catch(error => {
                    console.log(error);
                    this.halamanloading = false;
                    window.location.replace("/");
                })
        },
        async AmbilDataRegister() {
            this.halamanloading = true;
            JSON.parse(localStorage.getItem("userLogin"));
            const mainAPIMaster = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            });
            await mainAPIMaster.get("reff/register?sumberDana=" + this.sumberdanafilter + "&lender=" + this.kddonorfilter)
                .then(
                    Response => {
                        //console.log(Response.data.content);
                        this.register = [];
                        this.datamasterregister = Response.data.content;
                        this.datamasterregister.forEach((item) => {
                            this.register.push({
                                label: item.registerId + '-' + item.registerNm,
                                code: this.datamasterregister.indexOf(item) + 1,
                                tag: item.registerId,
                            });
                        });
                        this.register.unshift({
                            label: 'Semua Register',
                            code: 0,
                            tag: 'Semua Register',
                        });

                        //console.log(this.register);
                    }
                ).catch(error => {
                    console.log(error);
                    this.halamanloading = false;
                    //window.location.replace("/");
                });
        },
        async AmbilDataTahun() {
            this.halamanloading = true;
            JSON.parse(localStorage.getItem("userLogin"));
            const mainAPITahun = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            });
            await mainAPITahun.get("progres/tahun")
                .then(
                    Response => {
                        this.datatahun = Response.data.content;
                        //console.log(this.datatahun);
                        //this.selected = document.getElementById('pilihantahun').options[0].text;
                        this.datatahun.forEach((item) => {
                            this.tahun.push({
                                label: item,
                                code: this.datatahun.indexOf(item),
                            });
                        });
                        //console.log(this.tahunfilter);
                    }
                ).catch(error => {
                    console.log(error);
                    this.halamanloading = false;
                    //window.location.replace("/");
                });
        },
        async AmbilDataRekap() {
            this.halamanloading = true;
            JSON.parse(localStorage.getItem("userLogin"));
            const mainAPIRekap = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            });
            await mainAPIRekap.get("kontraktual/per-paket/nested?tahun=" + this.tahunfilter +
                "&includePaket=true&realisasi=&includeRegister=false&includeKppn=false&includeBeban=false&includeMetode=false&hasLoanOnly=" + this.hasLoanOnlyfiler
                + "&hasSbsnOnly=" + this.hasSbsnOnlyfilter + "&kdsatker="
                + this.kdsatkerfilter + "&kdbalai=" + this.kdbalaifilter + "&register=" + this.koderegisterfilter + "&lender=" + this.kddonorfilter)
                .then(
                    Response => {
                        this.datarekap = Response.data;
                        this.totalpagu = this.datarekap.content.reduce((a, { pg: e }) => a + e, 0);
                        this.totalrealisasi = this.datarekap.content.reduce((a, { nkon: e }) => a + e, 0);
                        //console.log("Total: "+this.totalpagu);
                        //console.log("Total: "+this.totalrealisasi);
                        this.totalrata2keu = this.datarekap.content.reduce((a, { sisaLelang: e }) => a + e, 0);
                        this.totalrata2fisik = this.datarekap.content.reduce((a, { fisikPrs: e }) => a + e, 0);
                        const jumlahdata = this.datarekap.content.length;
                        if (jumlahdata != 0) {
                            this.rata2keu = this.totalrata2keu / jumlahdata;
                            this.rata2fisik = this.totalrata2fisik / jumlahdata;
                        }
                        if (this.totalpagu == 0) {
                            this.rata2keu = 0;
                            this.rata2fisik = 0;
                        }
                        //console.log(this.datarekap);
                        this.datatabel = Response.data.content;
                        this.tanggaldata = this.datarekap.tanggalEmon;
                        this.updatedataprogres();
                        this.halamanloading = false;
                    }
                ).catch(error => {
                    console.log(error);
                    this.halamanloading = false;
                    //window.location.replace("/");
                });


        },
        updatedataprogres() {
            this.halamanloading = true;
            this.detailtabel = [];
            this.aditjumlah = [];
            this.totalpagupaket = 0;
            for (let i = 0; i < this.datatabel.length; i++) {
                for (let z = 0; z < this.datatabel[i].childs.length; z++) {
                    for (let c = 0; c < this.datatabel[i].childs[z].childs.length; c++) {
                        this.aditjumlah.push(this.datatabel[i].childs[z].childs[c].paket);
                    }
                }
            }

            for (let i = 0; i < this.datatabel.length; i++) {
                this.totalbalai = 0;
                let found = this.balai.find((element) => element.code == this.datatabel[i].kdbalai);
                for (let jumbalai = 0; jumbalai < this.aditjumlah.length; jumbalai++) {
                    try {
                        if (this.aditjumlah[jumbalai].kdbalai == this.datatabel[i].kdbalai) {
                            try {
                                this.totalbalai = this.totalbalai + this.aditjumlah[jumbalai].pg;
                            } catch (error) {
                                this.totalbalai = this.totalbalai + 0;
                            }
                        }
                    } catch (error) {
                        this.totalbalai = this.totalbalai + 0;
                    }
                }
                this.detailtabel.push({
                    "No": i + 1,
                    "Kode": "",
                    "Kegiatan": found.label,
                    "status": '',
                    "proyeks": '',
                    "kdbalai": this.datatabel[i].kdbalai,
                    "kdsatker": this.datatabel[i].kdsatker,
                    "pg": this.datatabel[i].pg,
                    "pgp": this.datatabel[i].pgp,
                    "nkon": this.datatabel[i].nkon,
                    "sisaLelang": this.datatabel[i].sisaLelang,
                    "nmKategori": '',
                    "nomorKontrak": '',
                    "rknName": '',
                    "tanggalKontrak": '',
                    "nmMetode": '',
                    "kdkppns": '',
                    "kdbebans": '',
                    "tahapanSkrg": '',
                    "KodePaket": '',
                    "PaguPaket": this.totalbalai,
                    "Class": "kolompusat",
                })
                for (let z = 0; z < this.datatabel[i].childs.length; z++) {
                    this.totalsatker = 0;
                    for (let jumsakter = 0; jumsakter < this.aditjumlah.length; jumsakter++) {
                        try {
                            if (this.aditjumlah[jumsakter].kdsatker == this.datatabel[i].childs[z].kdsatker) {
                                try {
                                    this.totalsatker = this.totalsatker + this.aditjumlah[jumsakter].pg;
                                } catch (error) {
                                    this.totalsatker = this.totalsatker + 0;
                                }
                            }
                        } catch (error) {
                            this.totalsatker = this.totalsatker + 0;
                        }
                    }
                    this.detailtabel.push({
                        "No": (i + 1) + "." + (z + 1),
                        "Kode": this.datatabel[i].childs[z].kode,
                        "Kegiatan": this.datatabel[i].childs[z].nmsatker || '',
                        "status": '',
                        "proyeks": '',
                        "kdbalai": this.datatabel[i].kdbalai,
                        "kdsatker": this.datatabel[i].childs[z].kdsatker,
                        "pg": this.datatabel[i].childs[z].pg || '0',
                        "pgp": this.datatabel[i].childs[z].pgp || '0',
                        "nkon": this.datatabel[i].childs[z].nkon,
                        "sisaLelang": this.datatabel[i].childs[z].sisaLelang,
                        "nmKategori": '',
                        "nomorKontrak": '',
                        "rknName": '',
                        "tanggalKontrak": '',
                        "nmMetode": '',
                        "kdkppns": '',
                        "kdbebans": '',
                        "tahapanSkrg": '',
                        "KodePaket": '',
                        "PaguPaket": this.totalsatker,
                        "Class": "kolomkegiatan",
                    })
                    for (let c = 0; c < this.datatabel[i].childs[z].childs.length; c++) {
                        this.adit = [];
                        this.adit.push(this.datatabel[i].childs[z].childs[c].paket);
                        var pagupaket = 0;
                        try {
                            pagupaket = this.adit[0].pg;
                        }
                        catch (err) {
                            pagupaket = 0;
                        }
                        this.totalpagupaket = this.totalpagupaket + pagupaket;
                        this.detailtabel.push({
                            "No": (i + 1) + "." + (z + 1) + "." + (c + 1),
                            "Kode": this.datatabel[i].childs[z].childs[c].kode,
                            "Kegiatan": this.datatabel[i].childs[z].childs[c].nmpaket || '',
                            "status": this.datatabel[i].childs[z].childs[c].status || '',
                            "proyeks": this.datatabel[i].childs[z].childs[c].proyeks[0] || '',
                            "kdbalai": this.datatabel[i].childs[z].childs[c].kdbalai,
                            "kdsatker": this.datatabel[i].childs[z].childs[c].kdsatker,
                            "pg": this.datatabel[i].childs[z].childs[c].pg || '0',
                            "pgp": this.datatabel[i].childs[z].childs[c].pgp || '0',
                            "nkon": this.datatabel[i].childs[z].childs[c].nkon || '0',
                            "sisaLelang": this.datatabel[i].childs[z].childs[c].sisaLelang || '0',
                            "nmKategori": this.datatabel[i].childs[z].childs[c].nmKategori || '',
                            "nomorKontrak": this.datatabel[i].childs[z].childs[c].nomorKontrak || '',
                            "rknName": this.datatabel[i].childs[z].childs[c].rknName || '',
                            "tanggalKontrak": this.datatabel[i].childs[z].childs[c].tanggalKontrak || '',
                            "nmMetode": this.datatabel[i].childs[z].childs[c].nmMetode || '',
                            "kdkppns": this.datatabel[i].childs[z].childs[c].kdkppns[0] || '',
                            "kdbebans": this.datatabel[i].childs[z].childs[c].kdbebans[0] || '',
                            "tahapanSkrg": this.datatabel[i].childs[z].childs[c].tahapanSkrg || '',
                            "KodePaket": this.datatabel[i].childs[z].childs[c].paket || '',
                            "PaguPaket": pagupaket || '0',
                            "Class": "kolomsatker",
                        })
                    }
                }
            }
            localStorage.removeItem('BalaiRekapSDA');
            localStorage.removeItem('NamaBalaiRekapSDA');
            localStorage.removeItem('SatkerRekapSDA');
            localStorage.removeItem('NamaSatkerRekapSDA');
            localStorage.removeItem('ProyekRekapSDA');
            //localStorage.removeItem('RegisterRekapSDA');
            localStorage.removeItem('SumberDanaRekapSDA');
            localStorage.removeItem('LenderRekapSDA');
        },
    },
    created() {
        this.halamanloading = true;
    },
    beforeMount() {
        this.halamanloading = true;
        //alert(localStorage.getItem("BalaiRekapSDA"));
    },
    mounted() {
        this.halamanloading = true;
        this.initializeSelect2();
        this.AmbilDataTahun();
        this.AmbilDataBalai();
        this.AmbilDataDonor();
        this.AmbilDataRegister();
        this.AmbilDataSatker();

        if (localStorage.getItem("SumberDanaRekapSDA") != null) {
            this.sumberdanafilter = 'pln';
            if (localStorage.getItem("SumberDanaRekapSDA") == 'sbsn') {
                this.defaultSelectedSumberDana = {
                    code: 1,
                    label: 'SBSN'
                };
                this.sumberdanafilter = 'sbsn';
                this.hasSbsnOnlyfilter = true;
            }
        }
        if (localStorage.getItem("TahunRekapSDA") != null) {
            this.tahunfilter = localStorage.getItem("TahunRekapSDA");
            this.halamanloading = true;
            JSON.parse(localStorage.getItem("userLogin"));
            const mainAPITahun = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            });
            mainAPITahun.get("progres/tahun")
                .then(
                    Response => {
                        this.datatahun = Response.data.content;
                        //console.log(this.datatahun);
                        //this.selected = document.getElementById('pilihantahun').options[0].text;
                        this.datatahun.forEach((item) => {
                            if (item == localStorage.getItem("TahunRekapSDA")) {
                                //alert(item);
                                this.defaultSelectedTahun = {
                                    label: item,
                                    code: this.datatahun.indexOf(item),
                                };
                            }
                        });
                        localStorage.removeItem('TahunRekapSDA');
                    }
                ).catch(error => {
                    console.log(error);
                    this.halamanloading = false;
                    //window.location.replace("/");
                });
        }

        if (localStorage.getItem("BalaiRekapSDA") != null) {
            this.kdbalaifilter = localStorage.getItem("BalaiRekapSDA");
            this.defaultSelectedBalai = {
                code: this.kdbalaifilter,
                label: localStorage.getItem("NamaBalaiRekapSDA"),
            };
            if (localStorage.getItem("SatkerRekapSDA") == '0') {
                this.kdsatkerfilter = '';
                this.defaultSelectedSatker = {
                    code: "0",
                    label: 'Semua Satker',
                };
            }
            if (localStorage.getItem("SatkerRekapSDA") === null) {
                this.kdsatkerfilter = '';
                this.defaultSelectedSatker = {
                    code: "0",
                    label: 'Semua Satker',
                };
            }
        }

        if (localStorage.getItem("SatkerRekapSDA") != null) {
            if (localStorage.getItem("SatkerRekapSDA") == '0') {
                this.kdsatkerfilter = '';
                this.defaultSelectedSatker = {
                    code: "0",
                    label: 'Semua Satker',
                };
            }
            else {
                this.kdsatkerfilter = localStorage.getItem("SatkerRekapSDA");
                this.defaultSelectedSatker = {
                    code: this.kdsatkerfilter,
                    label: localStorage.getItem("NamaSatkerRekapSDA"),
                };
            }
        }
        if (localStorage.getItem("ProyekRekapSDA") != null) {
            this.kdProyekfilter = localStorage.getItem("ProyekRekapSDA");
        }

        if (localStorage.getItem("LenderRekapSDA") != null) {
            this.kddonorfilter = localStorage.getItem("LenderRekapSDA");
        }

        if (localStorage.getItem("RegisterRekapSDA") != null) {
            this.koderegisterfilter = localStorage.getItem("RegisterRekapSDA");
            this.halamanloading = true;
            JSON.parse(localStorage.getItem("userLogin"));
            const mainAPIMaster = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            });
            mainAPIMaster.get("reff/register?sumberDana=" + this.sumberdanafilter)
                .then(
                    Response => {
                        //console.log(Response.data.content);
                        this.datamasterregister = Response.data.content;
                        this.datamasterregister.forEach((item) => {
                            if (item.registerId == localStorage.getItem("RegisterRekapSDA")) {
                                this.defaultSelectedRegister = {
                                    label: item.registerId + '-' + item.registerNm,
                                    code: this.datamasterregister.indexOf(item) + 1,
                                    tag: item.registerId,
                                };
                            }
                        });

                        localStorage.removeItem('RegisterRekapSDA');
                        //console.log(this.register);
                    }
                ).catch(error => {
                    console.log(error);
                    this.halamanloading = false;
                    //window.location.replace("/");
                });
        }

        this.AmbilDataRekap();
        document.getElementById('DashboardGrup').className = 'nav-item menu-open';
        document.getElementById('MonitoringGrup').className = 'nav-item menu-close';
        document.getElementById('PaketPipeLineGrup').className = 'nav-item menu-close';
        document.getElementById('PaketKontraktualGrup').className = 'nav-item menu-open';
        document.getElementById('PrognosisGrup').className = 'nav-item menu-close';
        document.getElementById('KendalaGrup').className = 'nav-item menu-close';
        document.getElementById('AWPGrup').className = 'nav-item menu-close';
        document.getElementById('PengecekanGrup').className = 'nav-item menu-close';
        document.getElementById('FormIsianGrup').className = 'nav-item menu-close';
        document.getElementById('KompilasiGrup').className = 'nav-item menu-close';
        document.getElementById('ADKGrup').className = 'nav-item menu-close';
        document.getElementById('ManajemenGrup').className = 'nav-item menu-close';
        document.getElementById('bodyLMS').className = 'hold-transition sidebar-mini layout-fixed';
        const sidebar = document.querySelector('aside');
        sidebar.style.display = 'block';
        const nav = document.querySelector('nav');
        nav.style.visibility = 'visible';
        //document.getElementById('Atas').style.visibility = 'visible';
        const footer = document.querySelector('footer');
        footer.style.visibility = 'visible';

        //this.halamanloading = false;

    },
};
</script>
      
<style></style>